import { getAPIURL } from '@utils/api'
import { useApi } from '@gravitate-js/the-armory'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getCurrentMarket } from '@utils/general'

export const useAnalyticsReporting = () => {
  const queryClient = useQueryClient()
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useForecastOverview = (filters: { end_date: string; start_date: string }) =>
    useQuery({
      queryKey: ['forecastOverview', filters],
      queryFn: () => api.post('reporting/forecast/overview', { ...filters, market: getCurrentMarket() }),
    })

  const useSalesOverview = (filters: { end_date: Date; start_date: Date }) =>
    useQuery({
      queryKey: ['salesOverview', filters],
      queryFn: () => api.post('reporting/sales/overview', { ...filters, market: getCurrentMarket() }),
    })

  const useTaxesOverview = (filters: { start: string; end: string }) =>
    useQuery({
      queryKey: ['taxesOverview', filters],
      queryFn: () => api.post('taxes/overview', { ...filters, market: getCurrentMarket() }),
    })

  const useBOLTransactionsOverview = (filters: { start: string; end: string }) =>
    useQuery({
      queryKey: ['bolTransactionsOverview', filters],
      queryFn: () => api.post('bol/valuation/overview', { ...filters, market: getCurrentMarket() }),
    })

  const useRecalculateBOLsMutation = () =>
    useMutation({
      mutationFn: (data: { order_number: string }) => api.post('bol/valuation/recalc', data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['bolTransactionsOverview'] })
      },
    })

  const useRecalculateTaxesMutation = () =>
    useMutation({
      mutationFn: (data: { order_number: string }) => api.post('taxes/recalc', data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['taxesOverview'] })
      },
    })

  return {
    useForecastOverview,
    useSalesOverview,
    useTaxesOverview,
    useBOLTransactionsOverview,
    useRecalculateBOLsMutation,
    useRecalculateTaxesMutation,
  }
}
